var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "px-10 flex flex-col justify-center items-center absolute w-full h-full top-0 left-0 bg-white bg-opacity-70 z-10"
};
const _hoisted_2 = { class: "flex flex-col w-full mr-1" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "w-full border-t border-gray-200 h-px" }, null, -1 /* HOISTED */);
const _hoisted_4 = { class: "flex flex-col items-center m-1" };
const _hoisted_5 = { class: "grid grid-cols-5 justify-center gap-4 mb-4" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "space-y-6" };
const _hoisted_8 = { class: "grid grid-cols-5 justify-center gap-4" };
const _hoisted_9 = ["onClick"];
import { fieldsMapping } from '@/compositions/imageAIFormFields';
import { getFormRules } from '@/compositions/imageAIFormRules';
import lodash from 'lodash';
import { ContentAIServices } from '../../service/ContentAIService';
import UINumberOfVariations from '../common/UINumberOfVariations.vue';
import UIImagePreview from '@/components/common/UIImagePreview.vue';
import { PlusIcon, RefreshCcw03Icon } from '@gohighlevel/ghl-icons/24/outline';
import { useNotification } from '@/compositions/useNotification';
import { DEFAULT_IMAGE_AI_STYLES, IMAGE_GENERATION_DEFAULTS, PENDO_MODULE_EVENT_NAME, STYLE_CATEGORY_ORDER, } from '@/helper/const';
import { EXAMPLE_AI_PROMPTS } from '@/helper/image-ai-prompt';
import { UIButton, UIForm, UIFormItem, UIInput, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISpace, UISpin, UITextSmMedium, UITextXsMedium, } from '@gohighlevel/ghl-ui';
import { computed, h, inject, onMounted, reactive, ref, watch, } from 'vue';
import { FormFieldTitle, } from '../../types';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalGenerateImageVariations',
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        productType: {
            type: String,
            require: true,
        },
        formData: {
            type: Object,
            default: function () {
                return {
                    description: IMAGE_GENERATION_DEFAULTS.DESCRIPTION,
                    numberOfVariations: IMAGE_GENERATION_DEFAULTS.NUMBER_OF_VARIATIONS,
                };
            },
        },
        pendoProperties: {
            type: Object,
        },
    },
    emits: ['close', 'showVariations'],
    setup(__props, { emit }) {
        var _a;
        const props = __props;
        const notification = useNotification();
        const store = inject('store');
        const route = inject('route');
        const emitter = inject('emitter');
        const locationId = (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id;
        const user = inject('user');
        const showModal = computed(() => props.showModal);
        const rules = computed(() => getFormRules(props.productType));
        const selectedStyle = ref(null);
        const showAllStyles = ref(false);
        const promptUsed = ref(false);
        const presetList = reactive([]);
        const loadPresets = () => __awaiter(this, void 0, void 0, function* () {
            try {
                initialLoading.value = true;
                const response = yield ContentAIServices.getAllImagePresets(locationId);
                if (response) {
                    const presets = response.data.presets;
                    const groupedPresets = presets.reduce((accumulator, preset) => {
                        if (!accumulator[preset.category]) {
                            accumulator[preset.category] = [];
                        }
                        accumulator[preset.category].push(preset);
                        return accumulator;
                    }, {});
                    Object.entries(groupedPresets).forEach(([category, presets]) => {
                        const curPresets = presets.map(preset => ({
                            id: preset.id,
                            src: preset.thumbnail,
                            title: preset.title,
                            key: preset.key,
                        }));
                        presetList.push({
                            title: category,
                            presets: curPresets,
                        });
                    });
                    // TODO: Move ordering presetList based on STYLE_CATEGORY_ORDER
                    presetList.sort((a, b) => {
                        const indexA = STYLE_CATEGORY_ORDER.indexOf(a.title);
                        const indexB = STYLE_CATEGORY_ORDER.indexOf(b.title);
                        if (indexA === -1 && indexB === -1)
                            return 0; // both are not in the order list, so retain their relative position
                        if (indexA === -1)
                            return 1; // a is not in the order list, so it should come after b
                        if (indexB === -1)
                            return -1; // b is not in the order list, so it should come after a
                        return indexA - indexB; // both are in the order list, sort by their position in the list
                    });
                }
                initialLoading.value = false;
            }
            catch (error) {
                console.error(error);
            }
        });
        // TODO: Instead of hard coding set defaults from backend
        // const defaultStyles = computed(() => {
        //   if (presetList.length > 0) {
        //     const allPresets = presetList.flatMap(category => category.presets)
        //     return allPresets.slice(0, 5)
        //   }
        //   return []
        // })
        function selectStyle(style) {
            if (style && !loading.value) {
                selectedStyle.value = style;
                formValue.value.preset = style.key;
            }
        }
        function openShowAllStyles() {
            showAllStyles.value = true;
        }
        function closeShowAllStyles() {
            showAllStyles.value = false;
        }
        const formFields = computed(() => fieldsMapping[props.productType]);
        const disableAction = computed(() => {
            var _a;
            return (((_a = formFields.value) === null || _a === void 0 ? void 0 : _a.required.filter((field) => {
                if (field === 'numberOfVariations' && !formValue.value[field]) {
                    return true;
                }
                else {
                    return !formValue.value[field];
                }
            }).length) > 0);
        });
        function setNumberOfVariation(variation) {
            formValue.value.numberOfVariations = variation;
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield loadPresets();
        }));
        const modalIcon = () => h('img', {
            src: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/640769bccb193579f29147db.svg+xml',
            class: 'w-6 h-6',
        });
        watch(showModal, () => {
            formValue.value.description = props.formData.description;
            formValue.value.numberOfVariations = props.formData.numberOfVariations;
            if (props.formData.preset) {
                openShowAllStyles();
                selectStyleByKey(props.formData.preset);
            }
        });
        const initialLoading = ref(false);
        const loading = ref(false);
        const errorMessage = ref([]);
        const root = ref();
        const dropDownContainer = ref();
        const formValue = ref({
            description: IMAGE_GENERATION_DEFAULTS.DESCRIPTION,
            numberOfVariations: IMAGE_GENERATION_DEFAULTS.NUMBER_OF_VARIATIONS,
            preset: IMAGE_GENERATION_DEFAULTS.PRESET,
        });
        function closeModal() {
            if (loading.value)
                return;
            emit('close');
            clearFormField();
            closeShowAllStyles();
        }
        function clearFormField() {
            if (loading.value)
                return;
            formValue.value = {
                description: IMAGE_GENERATION_DEFAULTS.DESCRIPTION,
                numberOfVariations: IMAGE_GENERATION_DEFAULTS.NUMBER_OF_VARIATIONS,
                preset: IMAGE_GENERATION_DEFAULTS.PRESET,
            };
            promptUsed.value = false;
            selectedStyle.value = undefined;
        }
        function errorHandler(errorMsg, statusCode) {
            var _a, _b, _c, _d;
            if (statusCode === 422 && Array.isArray(errorMsg)) {
                const fields = [
                    ...((_b = (_a = formFields === null || formFields === void 0 ? void 0 : formFields.value) === null || _a === void 0 ? void 0 : _a.required) !== null && _b !== void 0 ? _b : []),
                    ...((_d = (_c = formFields === null || formFields === void 0 ? void 0 : formFields.value) === null || _c === void 0 ? void 0 : _c.optional) !== null && _d !== void 0 ? _d : []),
                ];
                for (const field of fields) {
                    const error = errorMsg.filter(err => err.includes(field));
                    if (error.length) {
                        const msg = error[0].replace(field, FormFieldTitle[field]);
                        errorMessage.value.push(msg);
                    }
                }
            }
            else {
                errorMessage.value.push(errorMsg);
            }
        }
        function submit() {
            root.value
                .getForm()
                .validate()
                .then(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                try {
                    if (loading.value)
                        return;
                    loading.value = true;
                    const data = yield generateImageVariation();
                    if (data.id) {
                        openVariation(data.id);
                    }
                    loading.value = false;
                    const isExamplePrompt = EXAMPLE_AI_PROMPTS.some(promptObj => { var _a; return promptObj.prompt === ((_a = formValue.value) === null || _a === void 0 ? void 0 : _a.description); });
                    emitter.emit('pendo-track-event-content-ai', {
                        event: 'Content AI ' + PENDO_MODULE_EVENT_NAME[props.productType],
                        properties: Object.assign({ is_content_ai_generated: true, content_ai_type: 'Image', number_of_variations: (_a = formValue.value) === null || _a === void 0 ? void 0 : _a.numberOfVariations, description: (_b = formValue.value) === null || _b === void 0 ? void 0 : _b.description, preset: (_c = formValue.value) === null || _c === void 0 ? void 0 : _c.preset, is_example_prompt: isExamplePrompt }, props.pendoProperties),
                    });
                    clearFormField();
                }
                catch (error) {
                    showError(error);
                    loading.value = false;
                }
            }))
                .catch(error => {
                console.error(error);
            });
        }
        function showError(error) {
            var _a, _b, _c, _d, _e;
            const errorMsg = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            errorMessage.value = [];
            errorHandler(errorMsg, (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.statusCode);
            if ((_e = errorMessage.value) === null || _e === void 0 ? void 0 : _e.length)
                notification.create({
                    type: 'error',
                    title: errorMessage.value.join('\n'),
                });
        }
        let shuffledPrompts = lodash.shuffle(EXAMPLE_AI_PROMPTS);
        function addRandomPrompt() {
            if (shuffledPrompts.length === 0) {
                shuffledPrompts = lodash.shuffle(EXAMPLE_AI_PROMPTS);
            }
            const randomPrompt = shuffledPrompts.pop();
            formValue.value.description = randomPrompt.prompt;
            openShowAllStyles();
            selectStyleByKey(randomPrompt.style);
            promptUsed.value = true;
            root.value.getForm().validate();
        }
        function selectStyleByKey(presetKey) {
            const preset = presetList
                .flatMap(category => category.presets)
                .find(style => style.key === presetKey);
            selectStyle(preset);
        }
        function generateImageVariation() {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const body = {
                    description: (_a = formValue.value) === null || _a === void 0 ? void 0 : _a.description.trim(),
                    numberOfVariations: (_b = formValue.value) === null || _b === void 0 ? void 0 : _b.numberOfVariations,
                    locationId: (_c = route === null || route === void 0 ? void 0 : route.params) === null || _c === void 0 ? void 0 : _c.location_id,
                    userId: user === null || user === void 0 ? void 0 : user.id,
                    companyId: store.state.company.company.id,
                    type: props.productType,
                    preset: selectedStyle.value.key,
                };
                const response = yield ContentAIServices.generateImageVariations(body);
                if (response.data)
                    return response.data;
                throw Error('Something went wrong, please try again');
            });
        }
        function openVariation(id) {
            closeModal();
            emit('showVariations', id);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), { show: _unref(showModal) }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "image-ai-new-content-modal-header",
                        title: _ctx.$t('modalGenerateImageVariations.imageAIHeader'),
                        icon: modalIcon,
                        type: "custom",
                        description: _ctx.$t('common.thisIsPaidService'),
                        onClose: closeModal,
                        class: "pb-2"
                    }, null, 8 /* PROPS */, ["title", "description"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('modalGenerateImageVariations.generate'),
                        negativeText: _ctx.$t('modalGenerateImageVariations.clear'),
                        onPositiveClick: submit,
                        onNegativeClick: clearFormField,
                        id: "image-ai-new-modal-footer",
                        loading: loading.value,
                        disabled: _unref(disableAction)
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "dropDownContainer",
                        ref: dropDownContainer,
                        id: "image-ai-new-content-modal-form-select-context-wrapper"
                    }, null, 512 /* NEED_PATCH */),
                    _createVNode(_unref(UIModalContent), {
                        id: "image-ai-new-content-modal-content",
                        class: "overflow-auto",
                        style: { "max-height": "570px" }
                    }, {
                        default: _withCtx(() => [
                            (initialLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createVNode(_unref(UISpin), { size: "large" })
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", null, [
                                _createVNode(_unref(UIForm), {
                                    ref_key: "root",
                                    ref: root,
                                    model: formValue.value,
                                    rules: _unref(rules),
                                    id: "image-ai-new-content-modal-form"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(UIFormItem), {
                                            label: _ctx.$t('modalGenerateImageVariations.describeYourImage'),
                                            path: "description",
                                            "show-require-mark": true
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_2, [
                                                    _createVNode(_unref(UIInput), {
                                                        type: "textarea",
                                                        modelValue: formValue.value.description,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formValue.value.description) = $event)),
                                                        placeholder: _ctx.$t('modalGenerateImageVariations.descriptionPlaceholder'),
                                                        id: "image-ai-new-content-modal-form-input-description",
                                                        class: "mb-2",
                                                        disabled: loading.value
                                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled"]),
                                                    _createVNode(_unref(UIButton), {
                                                        id: "image-ai-new-add-example-input-description-btn",
                                                        onClick: addRandomPrompt,
                                                        size: "small",
                                                        disabled: loading.value
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UISpace), { justify: "space-between" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(UITextSmMedium), null, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(!promptUsed.value
                                                                                ? _ctx.$t('modalGenerateImageVariations.tryAnExample')
                                                                                : _ctx.$t('modalGenerateImageVariations.tryAnother')), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    }),
                                                                    (!promptUsed.value)
                                                                        ? (_openBlock(), _createBlock(_unref(PlusIcon), {
                                                                            key: 0,
                                                                            class: "w-4 h-4 mt-0.5"
                                                                        }))
                                                                        : (_openBlock(), _createBlock(_unref(RefreshCcw03Icon), {
                                                                            key: 1,
                                                                            class: "w-4 h-4 mt-0.5"
                                                                        }))
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["disabled"])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]),
                                        _createVNode(_unref(UIFormItem), {
                                            label: _ctx.$t('modalGenerateImageVariations.numberOfVariations'),
                                            path: "numberOfVariations",
                                            "show-require-mark": true
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(UINumberOfVariations, {
                                                    "number-of-variations": formValue.value.numberOfVariations,
                                                    onUpdate: setNumberOfVariation,
                                                    max: 4,
                                                    disabled: loading.value
                                                }, null, 8 /* PROPS */, ["number-of-variations", "disabled"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]),
                                        _hoisted_3,
                                        _createVNode(_unref(UIFormItem), {
                                            label: _ctx.$t('modalGenerateImageVariations.chooseStyle'),
                                            class: "mt-4",
                                            path: "preset",
                                            "show-require-mark": true
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_4, [
                                                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DEFAULT_IMAGE_AI_STYLES), (style) => {
                                                            var _a;
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: style === null || style === void 0 ? void 0 : style.key,
                                                                onClick: ($event) => (selectStyle(style)),
                                                                class: "flex flex-col items-center p-1"
                                                            }, [
                                                                _createVNode(UIImagePreview, {
                                                                    imageSrc: style === null || style === void 0 ? void 0 : style.src,
                                                                    width: "80px",
                                                                    height: "80px",
                                                                    borderWidth: "4px",
                                                                    class: "mb-2",
                                                                    style: _normalizeStyle(((_a = selectedStyle.value) === null || _a === void 0 ? void 0 : _a.key) === (style === null || style === void 0 ? void 0 : style.key)
                                                                        ? 'border: 2px solid #155EEF;'
                                                                        : '')
                                                                }, null, 8 /* PROPS */, ["imageSrc", "style"]),
                                                                _createVNode(_unref(UITextXsMedium), null, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(style.title), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */)
                                                            ], 8 /* PROPS */, _hoisted_6));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vShow, !showAllStyles.value]
                                                    ]),
                                                    _withDirectives(_createVNode(_unref(UIButton), {
                                                        id: "image-ai-show-all-styles-btn",
                                                        onClick: openShowAllStyles,
                                                        class: "items-center"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('modalGenerateImageVariations.seeAll')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 512 /* NEED_PATCH */), [
                                                        [_vShow, !showAllStyles.value]
                                                    ]),
                                                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presetList, (category) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: category.id
                                                            }, [
                                                                _createVNode(_unref(UITextSmMedium), { class: "mb-2 mt-2" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(category.title), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                                _createElementVNode("div", _hoisted_8, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.presets, (style) => {
                                                                        var _a;
                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                            key: style === null || style === void 0 ? void 0 : style.key,
                                                                            onClick: ($event) => (selectStyle(style)),
                                                                            class: "flex flex-col items-center p-1"
                                                                        }, [
                                                                            _createVNode(UIImagePreview, {
                                                                                imageSrc: style === null || style === void 0 ? void 0 : style.src,
                                                                                width: "80px",
                                                                                height: "80px",
                                                                                borderWidth: "4px",
                                                                                class: "mb-2",
                                                                                style: _normalizeStyle(((_a = selectedStyle.value) === null || _a === void 0 ? void 0 : _a.key) === (style === null || style === void 0 ? void 0 : style.key)
                                                                                    ? 'border: 2px solid #155EEF;'
                                                                                    : '')
                                                                            }, null, 8 /* PROPS */, ["imageSrc", "style"]),
                                                                            _createVNode(_unref(UITextXsMedium), { class: "mt-1.5" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(style.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                                        ], 8 /* PROPS */, _hoisted_9));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vShow, showAllStyles.value]
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["model", "rules"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
